/**
 * Visualization-specific enums.
 *
 * These enums govern the explore tool's visualization modes, view types,
 * color schemes, and related display options. They live in the data
 * package because param schemas and settings config depend on them,
 * and data is lower in the dependency graph than viz or controls.
 */

export enum UIView {
  Markets = "markets",
  Products = "products",
}

export enum VizType {
  Tree = "treemap",
  Geo = "geomap",
  OverTime = "overtime",
  MarketShare = "marketshare",
  ProductSpace = "productspace",
  Feasibility = "feasibility",
}

export enum ColorBy {
  Sector = "sector",
  Green = "green",
  Complexity = "complexity",
  Cluster = "cluster",
}

export enum LegendLabels {
  Sector = "PRODUCT SECTORS",
  Green = "GREEN ENABLERS",
  Complexity = "PRODUCT COMPLEXITY",
  Cluster = "CLUSTERS",
  Region = "REGIONS",
  Gross = "GROSS TRADE",
  Net = "NET TRADE",
}

export enum TradeDirectionSelectorString {
  Exports = "exportValue",
  Imports = "importValue",
}

export enum MetadataMergeType {
  Region = "region",
  Sector = "sector",
}

export enum VizClassification {
  Trade = "tradeViz",
  Complexity = "complexityViz",
}

/**
 * Y-axis scaling options for overtime visualizations.
 *
 * Previously defined in `transformUtils.ts`; moved here so both
 * `vizUtils` and `transformUtils` can reference the enum without
 * circular imports.
 */
export enum ScalingOption {
  Current = "Current USD",
  Constant = "Constant USD",
  PerCapita = "Per Capita",
  PerCapitaConstant = "Per Capita Constant",
}

// ── Overtime chart options ──────────────────────────────────────────

export enum YAxisScalingOption {
  Current = "current",
  Constant = "constant",
  PerCapita = "perCapita",
  PerCapitaConstant = "perCapitaConstant",
}

export enum OverTimeOrderingOption {
  Community = "community",
  Totals = "totals",
}

export enum OverTimeLayoutOption {
  Value = "value",
  Share = "share",
}

// ── Growth / Feasibility chart options ──────────────────────────────

export enum OpportunitySizeOption {
  None = "None",
  WorldTrade = "WorldTrade",
  CountryTrade = "CountryTrade",
}

export enum HideWorldTradeOption {
  On = "On",
  Off = "Off",
}

// ── Top Products Table / Product Space sizing ───────────────────────

export enum NodeSizing {
  None = "None",
  WorldTrade = "WorldTrade",
  CountryTrade = "CountryTrade",
}
